import React, { useState, useEffect, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import HeaderM from "../../Invs/maintaince/A4/HeaderM";
import LoadingPage from "../../../services/LoadingPage";
import BodyInv from "./A4/BodyInv";
import FooterD from "./A4/FooterD";
import UnderHeader from "./A4/UnderHeader"
import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import BodyInvD from "./A4/BodyInvD";
import FooterDH from "./A4/FoooterD3";
import FooterD4 from "./A4/FooterD4";
import UnderHeadreCar from "../CarMaintance/UnderHeadreCar";
import BodyCar from "./A4/BodyCar";
import HeaderAll from "../../HeaderAll";
import UnderHeaderD from "../ItemsNotesDesign/UnderHeaderD";
import FooterNotes from "../ItemsNotesDesign/FooterNotes";
import FooterM from "../maintaince/A4/FooterM";
function BillPage(props) {
  // const { locInv, found, sta, inv, chunk } = props;
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const clas = useInvAF();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>
      <Fragment>
        {premiApp.billTemplate === 13 ? (
          <>

            <Grid xs={12} item >
              {found.header_img != null ? (
                (
                  <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                    <div>
                      <ButtonBase>
                        {" "}
                        <img
                          src={`data:image/jpeg;base64,${found.header_img}`}
                          className={clas.headerImg}
                          alt={found.nameA}
                        />{" "}
                      </ButtonBase>
                    </div>
                  </Grid>
                )
              ) :
                (<HeaderM locInv={locInv} foundData={found} sta={sta} />)
              }
              {/* <HeaderAll Report={false} found={found} /> */}
              <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
              <BodyInv
                data={chunk ?? []}
                isFullPage={!isFirst ? true : false}
                isLast={isLast}
                found={found}
                inv={inv} sta={sta}
                locInv={locInv}

              />
              <FooterD4 found={found} inv={inv} data={sta ?? {}} />

            </Grid>

          </>
        ) : (
          <>

            <Grid xs={12} item style={{ ...stElemnt.AF.Reviws.pdf_InvD }}>
              {found.header_img != null ? (
                (
                  <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                    <div>
                      <ButtonBase>
                        {" "}
                        <img
                          src={`data:image/jpeg;base64,${found.header_img}`}
                          className={clas.headerImg}
                          alt={found.nameA}
                        />{" "}
                      </ButtonBase>
                    </div>
                  </Grid>
                )
              ) :
                (<HeaderM locInv={locInv} foundData={found} sta={sta} />)
              }
              {premiApp.billTemplate === 14 ?
                <UnderHeadreCar found={found} inv={inv} sta={sta} locInv={locInv} /> :
                <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />}

              {premiApp.billTemplate !== 11 ? (
                <BodyInv
                  data={chunk ?? []}
                  isFullPage={!isFirst ? true : false}
                  isLast={isLast}
                  found={found}
                  inv={inv} sta={sta}
                  locInv={locInv}
                />) : (
                <>
                  <BodyInvD
                    data={chunk ?? []}
                    isFullPage={!isFirst ? true : false}
                    isLast={isLast}
                    found={found}
                    inv={inv} sta={sta}
                    locInv={locInv}

                  />
                  {premiApp.billTemplate === 13 && (
                    <FooterD4 found={found} inv={inv} data={sta ?? {}} />
                  )}
                </>
              )}

            </Grid>
            <Grid xs={12} item style={{ maxHeight: "5.5cm", minHeight: "5.5cm" }}>
              {premiApp.billTemplate === 13 ? null : premiApp.billTemplate === 14 ? null :
                premiApp.billTemplate === 13 ? null : premiApp.billTemplate === 12 || premiApp.billTemplate === 17 ? (
                  <FooterDH found={found} inv={inv} data={sta ?? {}} />
                ) : (<FooterD found={found} inv={inv} data={sta ?? {}} />)}


            </Grid>
          </>)}


      </Fragment>
    </Grid>
  );
}


function BillPageCar(props) {
  // const { locInv, found, sta, inv, chunk } = props;
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const clas = useInvAF();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_pageCar }}>
      <Fragment>

        <Grid xs={12} item >
          {found.header_img != null ? (
            (
              <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                <div>
                  <ButtonBase>
                    {" "}
                    <img
                      src={`data:image/jpeg;base64,${found.header_img}`}
                      className={clas.headerImg}
                      alt={found.nameA}
                    />{" "}
                  </ButtonBase>
                </div>
              </Grid>
            )
          ) :
            (<HeaderM locInv={locInv} foundData={found} sta={sta} />)
          }
          {/* <HeaderM locInv={locInv} foundData={found} sta={sta} /> */}
          {premiApp.billTemplate === 14 ?
            <UnderHeadreCar found={found} inv={inv} sta={sta} locInv={locInv} /> :
            <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />}

          <BodyCar
            data={chunk ?? []}
            isFullPage={!isFirst ? true : false}
            isLast={isLast}
            found={found}
            inv={inv} sta={sta}
            locInv={locInv}

          />

        </Grid>

      </Fragment>
    </Grid>
  );
}

function BillPageSevices(props) {
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const clas = useInvAF();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_pageCar }}>
      <Fragment>

        <Grid xs={12} item >
          {premiApp.billTemplate === 20 ?
            (
              <>
                <Grid xs={12} item style={{ ...stElemnt.AF.Reviws.pdf_InvD }}>
                  <HeaderAll Report={false} found={found} />
                  <UnderHeaderD found={found} inv={inv} sta={sta} locInv={locInv} />
                  <BodyInv
                    data={chunk ?? []}
                    isFullPage={!isFirst ? true : false}
                    isLast={isLast}
                    found={found}
                    inv={inv} sta={sta}
                    locInv={locInv}
                  />
                </Grid>
                <FooterM inv={inv} locInv={locInv} found={found} />
              </>
            ) :
            (
              <>
                <Grid xs={12} item style={{ ...stElemnt.AF.Reviws.pdf_InvSer }}>
                  <HeaderAll Report={false} found={found} />

                  <UnderHeaderD found={found} inv={inv} sta={sta} locInv={locInv} />
                  <BodyInv
                    data={chunk ?? []}
                    isFullPage={!isFirst ? true : false}
                    isLast={isLast}
                    found={found}
                    inv={inv} sta={sta}
                    locInv={locInv}
                  />
                </Grid>
                <FooterNotes inv={inv} locInv={locInv} found={found} />
              </>
            )}

        </Grid>
      </Fragment>
    </Grid>
  );
}
function cmToPx(cm) {
    return (cm*96)/2.54;
}

function RevInvMain(props) {
    const { locInv, found, sta, inv,data } = props;
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
  const max_height_cm=(premiApp.billTemplate === 17|| premiApp.billTemplate === 12) ?11:15;
  const max_height=cmToPx(max_height_cm);


  const containerRef=useRef(null);
  const [pages,setPages]=useState([]);

  useEffect(() => {
    const pagesList=[];
    let currensPage=[];
    let currentHeight=0;
    const premiAppp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const measureDiv=document.createElement("div");
    measureDiv.style.visibility="hidden";
    measureDiv.style.position="absolute";
    measureDiv.style.width="100%";
    document.body.appendChild(measureDiv);

    const cellSD4 = {

        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        border: "solid 0.1px",
        fontSize: "0.7rem",
        width: "300px",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        direction: "rtl",
      };
    data.forEach((row)=>{
        const rowElement=document.createElement("div");
        rowElement.innerHTML=row.notesall;
        rowElement.style.borderBottom="1px solid #ccc";
        rowElement.style.padding="8px";
        if ( premiAppp.billTemplate === 17 || premiAppp.billTemplate === 12 ){
            rowElement.innerHTML=`
            <div>${row.notes_details}</div>
            <div style={${cellSD4}}>${row.notesall}</div>
            `;
        }else{
            rowElement.innerHTML=`
            <div>${row.symbol}</div>
            `;
        }
        measureDiv.appendChild(rowElement);
        const rowHeight=rowElement.offsetHeight;
        measureDiv.innerHTML="";

        if (currentHeight+rowHeight>max_height){
            pagesList.push(currensPage);
            currensPage=[row];
            currentHeight=rowHeight;
        }else{
            currensPage.push(row);
            currentHeight +=rowHeight;
        }
    });


    if (currensPage.length>0) pagesList.push(currensPage);
    document.body.removeChild(measureDiv);

    setPages(pagesList);
   
  }, [data]);



//   if (!found || !sta || loading) return <LoadingPage />;


  return (
    <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>

      {/* <Typography component="div" style={{ ...stElemnt.AF.Reviws.pdf_page }}> */}
      <Typography component="div" >
        {/* {chunks.map((page, i) => { */}
        {pages.map((page, i) => {

          return (
            <div key={i}>
              {premiApp.billTemplate === 14 ? (
                <BillPageCar
                  {...{
                    locInv,
                    found,
                    sta,
                    inv,
                    chunk: page,
                    isFirst: i == 0,
                    isLast: i == pages.length - 1,
                  }}
                />
              ) : premiApp.billTemplate === 17 || premiApp.billTemplate === 20?
                (
                  (
                    <BillPageSevices
                      {...{
                        locInv,
                        found,
                        sta,
                        inv,
                        chunk: page,
                        isFirst: i == 0,
                        isLast: i == pages.length - 1,
                      }}
                    />
                  )
                ) :
                (
                  <BillPage
                    {...{
                      locInv,
                      found,
                      sta,
                      inv,
                      chunk: page,
                      isFirst: i == 0,
                      isLast: i == pages.length - 1,
                    }}
                  />
                )}
            </div>
          );
        })}
      </Typography>
    </Typography>
  );
}
export default RevInvMain;
